import { faBookOpen, faChartPie } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Box, GridProps, GridSize, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import ButtonStyledLink from 'components/common/ButtonStyledLink';
import { AppRoutes } from 'types';
import HomeGridCard from './HomeGridCard';

const t = (key: string, options?) => translate('home', key, options);
type Props = {
  paperClass: string;
  xs: GridSize;
  isTrialLicense: boolean;
} & GridProps;

const AssignmentsAndReporting: React.FC<Props> = ({
  paperClass,
  xs,
  classes: parentClasses,
  isTrialLicense,
}) => {
  const classes = useStyles();
  return (
    <HomeGridCard
      xs={xs}
      paperProps={{ className: paperClass }}
      boxProps={{ justifyContent: 'space-evenly', margin: '0 12px 12px' }}
      classes={parentClasses}
    >
      <Box className={classes.content}>
        <Typography variant="h2" style={{ fontWeight: 'bold' }}>
          {t('assignmentsAndReporting')}
        </Typography>
        <Typography variant="subtitle1">{t('assignAlphabetActivities')}</Typography>
      </Box>
      <Box className={classes.content} display="flex" justifyContent="flex-start" flexWrap="wrap">
        <ButtonStyledLink
          to={`/${AppRoutes.ASSIGNMENTS}`}
          from={RouteSource.DASHBOARD}
          className={`${classes.button} ${classes.firstButton}  ${
            isTrialLicense && classes.disable
          }`}
          variant="outlined"
        >
          <FontAwesomeIcon size="sm" icon={faBookOpen} className={classes.iconClass} />
          <Typography className={classes.text} variant="subtitle1">
            {t('studentAssignments')}
          </Typography>
        </ButtonStyledLink>
        <ButtonStyledLink
          className={`${classes.button} ${isTrialLicense && classes.disable}`}
          variant="outlined"
          to={`/${AppRoutes.REPORTS}`}
        >
          <FontAwesomeIcon size="sm" icon={faChartPie} className={classes.iconClass} />
          <Typography className={classes.text} variant="subtitle1">
            {t('studentReporting')}
          </Typography>
        </ButtonStyledLink>
      </Box>
    </HomeGridCard>
  );
};

const useStyles = makeStyles(() => ({
  iconClass: {
    margin: '0 8px 0 0',
  },
  content: {
    margin: 12,
  },
  text: {
    paddingTop: 4,
  },
  button: {
    borderWidth: '2px !important',
  },
  firstButton: {
    marginRight: '20px',
  },
  disable: {
    pointerEvents: 'none',
    borderColor: 'rgba(0, 0, 0, 0.26)',
    color: 'rgba(0, 0, 0, 0.26)',
  },
}));

export default AssignmentsAndReporting;
